import { render } from "./notification-component.vue?vue&type=template&id=140cdacb&ts=true"
import script from "./notification-component.vue?vue&type=script&lang=ts"
export * from "./notification-component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__